import { createSlice } from "@reduxjs/toolkit";
import { addVoice, editVoice, getVoice, getVoiceList } from "../services/voice-services";


const initialState = {
  voices: [],
  voice: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const voiceSlice = createSlice({
  name: "voice",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVoiceList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getVoiceList.fulfilled, (state, action) => {
        state.voices = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getVoiceList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getVoice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getVoice.fulfilled, (state, action) => {
        state.voices = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getVoice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addVoice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addVoice.fulfilled, (state, action) => {
        state.voices = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addVoice.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editVoice.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editVoice.fulfilled, (state, action) => {
        state.voices = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editVoice.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = voiceSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default voiceSlice.reducer;
